export const CONTENT = {
  brand: 'ProMax',
  tagline: 'رتّب راتبك بوضوح.',
  cta: 'احصل على ProMax',
  income: 8000,
  expenses: 5300,
  debt: 1000,
  quickExpense: 25,
  currency: 'ر.س',
};

export const TIMELINE = [
  {id:'face',name:'01 · الإنسان والإشعار',from:0,duration:75},
  {id:'phone',name:'02 · متابعة الحركة نزولًا',from:75,duration:69},
  {id:'life',name:'03 · شخص حقيقي',from:144,duration:60},
  {id:'product',name:'04 · دخول إلى لوحة ProMax',from:204,duration:111},
  {id:'surplus',name:'05 · تركيز العين على الفائض',from:315,duration:93},
  {id:'quick-add',name:'06 · تسجيل القهوة',from:408,duration:117},
  {id:'save',name:'07 · حفظ الخطة',from:525,duration:105},
  {id:'closing',name:'08 · الهوية والشراء',from:630,duration:120},
] as const;

export const FPS = 30;
export const DURATION = 750;
